import React from 'react';

import { cn } from '@change/ds-utils';

import { SkeletonContainer } from 'src/app/pages/starterDashboardV2/shared/components';

import { type Platform, PLATFORM_CONFIG } from '../../../../shared/constants';

type Props = Readonly<{
	platform?: Platform;
}>;

export const SocialContentPreviewLoading: React.FC<Props> = ({ platform = 'instagram' }) => {
	const { Icon, bgGradient, bgColor, iconColor, brandLabel } = PLATFORM_CONFIG[platform];

	return (
		<SkeletonContainer loading>
			<div
				data-platform={platform}
				data-testid={`placeholder-social-content-${platform}`}
				className="relative"
				aria-hidden="true"
			>
				<div className="relative rounded-2xl bg-[#E1DDE9] p-4">
					<div
						className={cn(
							'absolute -right-2 -top-2 z-10 flex h-10 w-10 items-center justify-center rounded-full shadow-lg',
							bgGradient,
						)}
						style={!bgGradient ? { backgroundColor: bgColor } : undefined}
						data-testid={`${platform}-badge`}
						aria-label={`${brandLabel} platform`}
					>
						<Icon className={cn(iconColor, 'h-6 w-6')} size={24} aria-hidden="true" />
					</div>
					<div className="w-[7.2rem] overflow-hidden rounded-xl border-2 border-white bg-white shadow-sm">
						<div className="h-[4.5rem] w-full animate-pulse bg-[#E1DDE9]" />
						<div className="h-20 w-full bg-white p-3"></div>
					</div>
				</div>
			</div>
		</SkeletonContainer>
	);
};
